import React, { Component } from 'react'
import { CancelToken } from 'axios'
import { withRouter } from 'react-router-dom'
import { Select, Empty, Avatar } from 'antd'
import { connect } from 'react-redux'
import { stringsHelp } from '../helpers'
import { institutionService } from '../services'

const Option = Select.Option

class SelectMultipleInstitutions extends Component {
  state = {
    dataPatients: [],
    value: undefined,
    textSearch: '',
    searchingPatients: false,
    groupInstitutions: []
  };

  cancelSource = CancelToken.source();

  handleChange = value => {
    if (value) {
      this.setState({ value })
    } else {
      this.setState({ value: undefined })
    }

    if (typeof (this.props.onChange) === 'function') {
      this.props.onChange(value)
    }
  };

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.institution !== prevProps.institution) {
      this.setState({ value: this.props.institution })
    }
  }

  componentDidMount () {
    const selectedInstitution = JSON.parse(localStorage.getItem('selected-institution'))

    if (!selectedInstitution || !selectedInstitution.id) {
      return
    }

    institutionService.getInstitutionsByGroup(selectedInstitution.id)
      .then(groupInstitutions => {
        this.setState({ groupInstitutions: groupInstitutions || [] })
      })
      .catch(() => {
        this.setState({ groupInstitutions: [] })
      })
  }

  render () {
    const { notClinic = false } = this.props
    let { groupInstitutions } = this.state

    if (notClinic) {
      groupInstitutions = groupInstitutions.filter(value => !value.is_clinic)
    }

    let options = ''

    if (groupInstitutions.length > 0) {
      options = groupInstitutions
        .map(institution => {
          return (
          <Option value={institution.id} key={institution.id} label={stringsHelp.firstLetterUpper(institution.name, true)}>
               <div className="ant-list-item-meta ant-group" style={{ marginTop: 5 }}>
                <div className="ant-list-item-meta-avatar">
                  <Avatar
                    shape="square"
                    src={
                      institution.logo_url
                        ? institution.logo_url
                        : null
                    }
                    className="institution-logo"
                  >
                    Logo
                  </Avatar>
                </div>
                <div className="ant-list-item-meta-content">
                  <h4
                    className="ant-list-item-meta-title"
                    style={{ marginBottom: -5 }}
                  >
                    {stringsHelp.firstLetterUpper(institution.name, true)}
                  </h4>
                </div>
              </div>
          </Option>
          )
        })
    }

    return (
      <Select
      className="select-institution-group"
        style={{ width: '100%' }}
        allowClear={false}
        value={!this.props.value ? this.state.value : this.props.value}
        placeholder={'Selecione a instituição'}
        defaultActiveFirstOption={false}
        showArrow={true}
        filterOption={false}
        onChange={this.handleChange}
        notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={' '} />}
        mode="multiple"
        optionLabelProp="label"
      >
        {options}
      </Select>
    )
  }
}

function mapStateToProps (state) {
  const { institutions } = state
  return {
    institutions
  }
}

const connected = withRouter(
  connect(mapStateToProps)(SelectMultipleInstitutions)
)

export default connected
